import Form from "../account/Form";
import LoginForm from "../account/LoginForm";
import ActivationPage from "../account/ActivationPage";
import Error from "../account/Error";
import Choice from "../account/Choice";
import UserFirstTheme from "../account/UserFirstTheme";

Vue.component("Error", Error);
Vue.component("Choice", Choice);
Vue.component("LoginForm", LoginForm);
Vue.component("ActivationPage", ActivationPage);
Vue.component("UserFirstTheme", UserFirstTheme);
window.Form = Form;

new Vue({
  el: "#app"
});
